import { LocationNumbersService } from '../../../services'

const transferNumberBetweenPools = async function ({ commit, dispatch, state }, payload) {
  const { locationId, sourcePoolId, destinationPoolId, phoneNumber } = payload

  commit('startLoading')
  try {
    const result = await LocationNumbersService.transferNumberBetweenPools({
      locationId,
      sourcePoolId,
      destinationPoolId,
      phoneNumber,
    })

    await dispatch('fetchNumberPool', {
      numberPools: state.numberPoolIDs,
      locationId: locationId,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: state.table?.searchText ?? '',
      },
      getPaginatedDataOnly: false,
    })

    commit('stopLoading')
    return result
  } catch (error) {
    commit('stopLoading')
    throw error
  }
}

export default transferNumberBetweenPools
